import {
  USER_AUTHENTICATED,
  AUTH_FLOW_PARAMS_INITIALIZED,
} from '../actions/index'

const initialState = {
  authData: null,
  redirectUri: null,
}

export default function authState(state = initialState, action) {
  switch (action.type) {
    case USER_AUTHENTICATED: {
      return {
        ...state,
        ...action.payload,
      }
    }
    case AUTH_FLOW_PARAMS_INITIALIZED: {
      return {
        ...state,
        ...action.payload,
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js